module.exports = "<button nvDisabled\n        class=\"btn {{btnSize}} {{btnClass}}\"\n        (click)=\"onRemoveClick()\">\n    {{label ? label + '&nbsp;' : ''}}<i class=\"fa fa-trash\"></i>\n</button>\n"


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/src/app/components/nv-remove-button/nv-remove-button.component.html
// module id = ../../../../../src/app/components/nv-remove-button/nv-remove-button.component.html
// module chunks = 0